
import { ResponseStatusChartData } from "@/pages/admin/surveys/types/assignments";
import { StatusDistributionChart } from "../StatusDistributionChart";
import { ResponseRateChart } from "../ResponseRateChart";
import { ResponseByLocationChart } from "../ResponseByLocationChart";
import { ResponseByGenderChart } from "../ResponseByGenderChart";
import { ResponseByEmploymentTypeChart } from "../ResponseByEmploymentTypeChart";
import { ResponseByAgeChart } from "../ResponseByAgeChart";
import { ResponseByGenerationChart } from "../ResponseByGenerationChart";
import { TopPerformingSBUsChart } from "./TopPerformingSBUsChart";
import { TopPerformingManagersChart } from "./TopPerformingManagersChart";

type ChartsSectionProps = {
  statusData?: ResponseStatusChartData[];
  responseData?: { date: string; count: number }[];
  campaignId: string;
  selectedInstanceId?: string;
};

export function ChartsSection({ 
  statusData, 
  responseData,
  campaignId,
  selectedInstanceId
}: ChartsSectionProps) {
  return (
    <>
      <div className="grid gap-6 md:grid-cols-1">
        <ResponseRateChart data={responseData} />
      </div>
      
      <div className="grid gap-6 md:grid-cols-2">
        <ResponseByLocationChart 
          campaignId={campaignId} 
          instanceId={selectedInstanceId} 
        />
        <ResponseByGenderChart 
          campaignId={campaignId} 
          instanceId={selectedInstanceId} 
        />
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <ResponseByAgeChart 
          campaignId={campaignId} 
          instanceId={selectedInstanceId} 
        />
        <ResponseByGenerationChart 
          campaignId={campaignId} 
          instanceId={selectedInstanceId} 
        />
      </div>

      <div className="grid gap-6 md:grid-cols-1">
        <ResponseByEmploymentTypeChart 
          campaignId={campaignId} 
          instanceId={selectedInstanceId} 
        />
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <TopPerformingSBUsChart 
          campaignId={campaignId} 
          instanceId={selectedInstanceId} 
        />
        <TopPerformingManagersChart 
          campaignId={campaignId} 
          instanceId={selectedInstanceId} 
        />
      </div>
    </>
  );
}
